import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({  
    root: {
        maxWidth: 240,
        display: "inline-block",
        width: "100%",
        textAlign: "left",
        margin: 20,
        verticalAlign: "top"
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    textDate: {
        display: "block",
        fontSize: 30,
        fontWeight: 600,
    },
    textTime: {
        width: "100%",
        textAlign: "right",
        display: "block",
    },
    expand: {
        '&:hover': {
            borderRadius: 5
        },
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
}));

export default function Group({group}) {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setExpanded(!expanded);
    };

    let totalLabels = 0;
    group.orders.forEach(status => {
        totalLabels +=  status.count;
    })


    const d = new Date(group.created_at.replace(" ", "T"));
    return (
        <Card className={classes.root} >
            <CardContent style={{paddingBottom: 0}}>
                <div>
                    <span className={classes.textDate}> {d.getDate()} {monthNames[d.getMonth()]}</span>
                    <span className={classes.textTime}> {d.toString().substring(16, 21)} </span>
                </div>
                <Typography color="textSecondary" style={{marginTop: 20}}>
                    Etichette: {totalLabels}
                </Typography>
                <CardActions disableSpacing>
                    <IconButton
                    className={clsx(classes.expand, {
                        [classes.expandOpen]: expanded,
                    })}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    style={{flexGrow: 1, padding: 0}}
                    >
            <ExpandMoreIcon />
            </IconButton>
        </CardActions>
        </CardContent>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent style={{padding: 0}}>
                    <ul style={{transform: "translateX(-10px)", marginTop: 0}}>
                        <li>
                            <b>Nome File</b>: {group.name}
                        </li>
                        <li>
                            <b>Etichette</b>: {totalLabels}
                            <ul style={{transform: "translateX(-15px)"}}>
                                {    group.orders.map(status => {
                                    return <li key={status.count}>{group.id + status.status + status.count} : {status.count}</li>
                                })}
                            </ul>
                        </li>
                    </ul>
            </CardContent>
        </Collapse>
        </Card>
    );
}

const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

